import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { Tabs } from "../../../../../../components/layout/tabs/components/tabs/tabs.component";
import React from "react";
import { TabBuilder } from "../../../../../../components/layout/tabs/types/tab-builder";
import { FlyerDetailOverviewTab } from "../../features/flyer-detail-overview-tab/components/flyer-detail-overview-tab/flyer-detail-overview-tab.component";
import { FlyerDetailPageTab } from "../../features/flyer-detail-page-tab/components/flyer-detail-page-tab/flyer-detail-page-tab.component";
import { FlyerDetailCommentsTab } from "../../features/flyer-detail-comments-tab/components/flyer-detail-comments-tab.component";
import { mapFlyerToForm } from "../../types/flyer-detail-form/flyer-detail-form.functions";
import { FlyerDetailViewProps } from "./flyer-detail-view-tabs.props";

export const FlyerDetailViewTabs = withShowIf((props: FlyerDetailViewProps) => {
  const formValues = mapFlyerToForm(props.flyer);

  const canDeletePages = () =>
    Boolean(props.permissions?.canDelete) && !Boolean(props.flyer?.initialActivationDate);

  const tabBuilder = new TabBuilder()
    .add(
      "Overview",
      <FlyerDetailOverviewTab
        flyerId={props.flyer.id}
        permissions={props.permissions!}
        forceOpen={props.forceOpen}
        formErrors={props.formErrors}
        formRef={props.formRef}
        values={formValues}
      />
    )
    .add(
      "Pages",
      <FlyerDetailPageTab
        pages={props.flyer?.pageOverview}
        permissions={props.permissions!}
        isPageExportModalOpen={props.isPageExportModalOpen}
        canDelete={canDeletePages()}
        onClickPage={props.onClickPage}
        onDeletePage={props.onDeletePage}
        onAddPage={props.onAddPage}
      />
    )
    .add("Comments", <FlyerDetailCommentsTab flyerId={props.flyer.id} />);

  return (
    <Tabs
      ariaLabel="Design Layouts Tabs"
      currentTabValue={props.currentTabValue}
      shouldChangeTab={props.shouldChangeTab}
      handleTabChange={props.onTabChange}
      headerHeight={props.headerHeight}
      tabs={tabBuilder.getTabs()}
    />
  );
});
